import React from 'react';
import styled from '@emotion/styled';

const CardContainer = styled.div<{ padding?: string }>`
  div {
    position: relative;

    .card-head {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 12px;
      font-weight: 400;
      color: var(--black);

      .card-title {
        margin-bottom: 0;
        font-weight: 700;
        font-size: 14px;
        line-height: normal;
      }
    }

    .card-box {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding: ${({ padding }) => padding ?? '20px 30px 20px'};
      background: var(--white) 0 0 no-repeat padding-box;
      box-shadow: 0 3px 6px #00000029;
      border-radius: 6px;
      color: var(--black);
      font-size: 16px;
      width: 100%;
    }
  }
`;

type CardProps = {
  className?: string;
  title?: string;
  desc?: string;
  padding?: string;
  children: React.ReactNode;
};

const Card = ({ className, title, desc, padding, children }: CardProps) => (
  <CardContainer className={className} padding={padding}>
    {title && (
      <div className="card-head">
        <h4 className="card-title">{title}</h4>
        <p>{desc}</p>
      </div>
    )}

    <div className="card-box">{children}</div>
  </CardContainer>
);

export default Card;
